import { api } from '../../ApiHandler';

export const LogOutRequest = (): Promise<null> => {
	return api()
		.post(`/auth/logout`)
		.then(response => response.data);
};
